import { render, staticRenderFns } from "./mechanism_detail_info.vue?vue&type=template&id=59c83b88&"
import script from "./mechanism_detail_info.vue?vue&type=script&lang=js&"
export * from "./mechanism_detail_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports